module.exports = __webpack_public_path__ + "img/action-dark2.285aa8b7.svg";